// @ts-check

import React from "react";
import { useNavigate } from "react-router-dom";
import { IndexTable, Link, Text } from "@shopify/polaris";

import { useFormatCurrency } from "hooks/use-format-currency";

export const AdCampaignsTableRow = ({
  data,
  index,
  columns,
}) => {
  const formatCurrency = useFormatCurrency();
  const navigate = useNavigate();

  const handleAdCampaignClick = () => {
    navigate(`/ad-campaigns/${data.id}`);
  };

  return (
    <IndexTable.Row id={data.id} position={index}>
      <IndexTable.Cell>
        <Link
          removeUnderline
          onClick={handleAdCampaignClick}
        >
          <Text variant="bodyMd" as="span">{data.name}</Text>
        </Link>
      </IndexTable.Cell>
      {columns.includes("spend") && (
        <IndexTable.Cell>
          <Text variant="bodyMd" as="span" alignment="end" numeric>
            {formatCurrency(data.total_spend)}
          </Text>
        </IndexTable.Cell>
      )}
      {columns.includes("clicks") && (
        <IndexTable.Cell>
          <Text variant="bodyMd" as="span" alignment="end" numeric>
            {data.total_clicks}
          </Text>
        </IndexTable.Cell>
      )}
      {columns.includes("revenue") && (
        <IndexTable.Cell>
          <Text variant="bodyMd" as="span" alignment="end" numeric>
            {formatCurrency(data.total_revenue)}
          </Text>
        </IndexTable.Cell>
      )}
      {columns.includes("orders") && (
        <IndexTable.Cell>
          <Text variant="bodyMd" as="span" alignment="end" numeric>
            {data.total_orders}
          </Text>
        </IndexTable.Cell>
      )}
    </IndexTable.Row>
  );
}
